import React,{useEffect,useState} from "react";
import {Link,useNavigate} from "react-router-dom";
import "./caridoc-redesign.css";
import {auth} from "./firebase/firebase";

export function Header(){
 const [mobileOpen,setMobileOpen]=useState(false);
 const [isLoggedIn,setIsLoggedIn]=useState(false);
 const navigate=useNavigate();

 useEffect(()=>{
   const sync=()=>setIsLoggedIn(!!localStorage.getItem("user"));
   sync();
   window.addEventListener("auth-change",sync);
   window.addEventListener("storage",sync);
   return()=>{window.removeEventListener("auth-change",sync);window.removeEventListener("storage",sync)};
 },[]);

 const logout=async()=>{
   try{await auth.signOut()}catch(e){console.error("Firebase sign out failed",e)}
   localStorage.removeItem("user");
   setIsLoggedIn(false);
   window.dispatchEvent(new Event("auth-change"));
   navigate("/login");
 };

 const links=[
   ["Home","/"],
   ["Chapters","/chapters"],
   ["Case Studies","/cases"],
   ["Quiz","/quiz-list"],
   ["Fracture Quiz","/fracture-quiz"],
   ["Protocols","/protocols"],
   ["Medical Terms","/medical-terms"],
   ["Drug Appendix","/view-drug-refs"],
   ["Illustrations","/illustrations"],
   ["Subscribe","/subscribe"]
 ];

 const close=()=>setMobileOpen(false);

 return <header className="caridoc-header">
  <div className="caridoc-nav">
   <Link to="/" className="caridoc-brand" onClick={close}>
    <div className="caridoc-island-mark" aria-hidden="true">🌴</div>
    <div className="caridoc-brand-copy"><strong>CARI<span>DOC</span>.NET</strong><small>DR. DANGLEBEN'S EMT GUIDE</small></div>
   </Link>
   <nav className="caridoc-links" aria-label="Main navigation">
    {links.map(([n,u])=><Link key={u} to={u}>{n}</Link>)}
    {isLoggedIn
      ? <button className="caridoc-login" onClick={logout}>Logout</button>
      : <Link className="caridoc-login" to="/login">● &nbsp; Login</Link>}
   </nav>
   <button className="caridoc-menu" aria-label="Open menu" aria-expanded={mobileOpen} onClick={()=>setMobileOpen(!mobileOpen)}>☰</button>
  </div>
  <nav className={`caridoc-mobile ${mobileOpen?"show":""}`} aria-label="Mobile navigation">
   {links.map(([n,u])=><Link onClick={close} key={u} to={u}>{n}</Link>)}
   {isLoggedIn
     ? <button className="caridoc-login" onClick={()=>{close();logout()}}>Logout</button>
     : <Link className="caridoc-login" onClick={close} to="/login">Login</Link>}
  </nav>
 </header>
}
export default Header;
